import React from "react";
import { useTranslation } from "react-i18next";

/**
 * 群聊阶段指示条：显示所有阶段名称，当前阶段颜色高亮
 */
const PhaseIndicator = ({ currentPhase, phaseLabel, phases }) => {
  const { t } = useTranslation();
  const phaseList = phases || [];
  const currentIdx = phaseList.findIndex((x) => x.phaseId === currentPhase || x.name === phaseLabel);

  return (
    <div className="groupchat-phase-indicator">
      <div className="phase-names">
        {phaseList.length > 0 ? (
          phaseList.map((p, i) => {
            const isActive = i === currentIdx || p.phaseId === currentPhase || p.name === phaseLabel;
            const isPast = currentIdx >= 0 && i < currentIdx;
            return (
              <span
                key={p.phaseId || i}
                className={`phase-name-item ${isPast ? "done" : ""} ${isActive ? "active" : ""}`}
                title={p.name}
              >
                {p.name}
              </span>
            );
          })
        ) : (
          <span className="phase-name-item active">{phaseLabel || currentPhase || t("groupchat.current_phase")}</span>
        )}
      </div>
    </div>
  );
};

export default PhaseIndicator;
